import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as i18next from 'i18next';
import * as api from 'core/api';
import * as auth from 'core/auth';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class AccountSettingsComponent extends Vue {
    $auth: auth.AuthService; // Injected in G2S.init

    @Prop()
    user: api.UserAccount;

    accountDeleteVibile: boolean = false;
    accountDeleteStarted: boolean = false;

    onAccountDeleteStart() {
        this.accountDeleteStarted = true;

        this.$auth.deleteStart().then(
            () => {
                this.accountDeleteStarted = false;

                this.accountDeleteVibile = false;

                (<any>this.$root).$refs.dialogMessage.show({
                    title: i18next.t('title_check_email'),
                    text: i18next.t('label_account_removal_submitted', <any>{ i: this.user.email })
                });
            },
            (error) => {
                this.accountDeleteStarted = false;

                (<any>this.$root).$refs.dialogMessage.show({
                    title: i18next.t('error'),
                    text: (error.response.data && error.response.data.localizedMessage) ? error.response.data.localizedMessage : i18next.t('error_server_tryagain')
                });

                if (error.response) {
                    console.log('XHR failed', error.response.status, error.response.data);
                } else {
                    console.log('XHR error', error.message);
                }
            }
        );
    }
}
